/* ============================================================
   FICHA — dos ajustes de DOM (17 ago 2026)
     1. La barra de confianza, entre las TALLAS y el BOTON
     2. El aviso de entrega, sustituido por el texto del corte horario
   ============================================================ */
(function () {
  'use strict';

  /* ══════════ 1. BARRA DE CONFIANZA ══════════
     EN PAULINA JIMENEZ el orden es precio -> tallas -> barra -> boton.
     Como las tallas y el boton viven los dos dentro de
     .producto-nazalea__form, la barra tiene que entrar DENTRO del form.

     ⚠️⚠️ POR QUE HAY UN OBSERVADOR.
     `assets/pn-pack.js` hace `form.style.display = 'none'` para sustituir
     el formulario por su interfaz de packs. Todo lo que este dentro del
     form desaparece con el: ya paso con el aviso de "Stock limitado", que
     se veia en el Personalizador y no en la web.
     El observador vigila el form: si lo esconden, saca la barra fuera para
     que siga viendose, y la devuelve cuando reaparece.
     NO QUITARLO pensando que sobra. */

  function boton(form) {
    return form.querySelector('button[type="submit"]')
        || form.querySelector('[class*="anadir"]')
        || form.querySelector('button');
  }

  function dentro() {
    var barra = document.querySelector('.producto-nazalea__confianza');
    var form = document.querySelector('.producto-nazalea__form');
    if (!barra || !form) { return; }
    var add = boton(form);
    if (!add) { return; }
    if (barra.parentElement === add.parentElement && barra.nextElementSibling === add) { return; }
    add.parentElement.insertBefore(barra, add);
  }

  function fuera() {
    var barra = document.querySelector('.producto-nazalea__confianza');
    var form = document.querySelector('.producto-nazalea__form');
    if (!barra || !form || !form.parentElement) { return; }
    if (barra.nextElementSibling === form) { return; }
    form.parentElement.insertBefore(barra, form);
  }

  function formEscondido(form) {
    var k = window.getComputedStyle(form);
    return k.display === 'none' || k.visibility === 'hidden';
  }

  function decidir() {
    var form = document.querySelector('.producto-nazalea__form');
    if (!form) { return; }
    if (formEscondido(form)) { fuera(); } else { dentro(); }
  }

  function vigilar() {
    var form = document.querySelector('.producto-nazalea__form');
    if (!form || form.dataset.pnVigilado === '1' || !window.MutationObserver) { return; }
    form.dataset.pnVigilado = '1';
    new MutationObserver(decidir).observe(form, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
  }

  /* ══════════ 2. AVISO DE ENTREGA ══════════
     Antes: "Recíbelo entre el lunes 31 de agosto y miércoles 9 de
     septiembre", con fechas calculadas por el tema.
     Ahora: el corte horario, que crea urgencia sin inventar una fecha.

     ⚠️ SIN EMOJI, A PROPOSITO. El pilar narrativo de la marca
     (`pilar_narrativa_nusa`) dice: nada de emoji. La primera version
     llevaba un camion y se quito por eso.

     ⚠️ LA HORA VA EN NEGRITA (20 ago 2026, a peticion suya: queria que el
     texto resaltase). Por eso se escribe con `innerHTML` y no con
     `textContent`. La comparacion de "ya esta puesto" se sigue haciendo
     sobre el TEXTO PLANO, que es lo unico estable: comparar el HTML
     fallaria en cuanto el navegador normalizase comillas o espacios.

     ⚠️ El texto se reescribe por JS porque las fechas las calcula el
     Liquid/JS del tema y volverian a pisarlo. Por eso ademas hay un
     observador: si el tema repinta el aviso al cambiar de variante, se
     vuelve a poner el nuestro.

     ⚠️ SOLO SE TOCA EL TEXTO. El icono del camion es un hermano y se
     queda: por eso se escribe sobre el nodo interior y no sobre el
     contenedor entero.

     ⚠️ ES UNA AFIRMACION SOBRE LA OPERATIVA. Si un pedido de las 22:50 no
     se procesa esa misma noche, la frase es falsa. Si algun dia deja de
     cumplirse, hay que cambiarla. */

  var TEXTO = 'Haz tu pedido antes de las 23:00 y empezaremos a prepararlo hoy.';
  var HTML = 'Haz tu pedido antes de las <strong>23:00</strong> y empezaremos a prepararlo hoy.';

  function entrega() {
    var caja = document.querySelector('.producto-nazalea__entrega');
    if (!caja) { return; }
    var destino = caja.querySelector('p, span, div') || caja;
    if (destino.textContent.replace(/\s+/g, ' ').trim() === TEXTO) { return; }
    destino.innerHTML = HTML;
  }

  function vigilarEntrega() {
    var caja = document.querySelector('.producto-nazalea__entrega');
    if (!caja || caja.dataset.pnVigilada === '1' || !window.MutationObserver) { return; }
    caja.dataset.pnVigilada = '1';
    new MutationObserver(entrega).observe(caja, { childList: true, subtree: true, characterData: true });
  }

  function iniciar() {
    decidir(); vigilar();
    entrega(); vigilarEntrega();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  document.addEventListener('shopify:section:load', iniciar);
  setTimeout(iniciar, 600);
  setTimeout(iniciar, 1500);
})();